import { all, takeLatest } from "redux-saga/effects";

import { ActivationTypes } from "../redux/ActivationReducer";

/* TYPES */
import { InitAppTypes } from "../redux/InitAppReducer";
import { PaymentTypes } from "../redux/PaymentReducer";
import { ProductsTypes } from "../redux/ProductsReducer";
import { UserTypes } from "../redux/UserReducer";
import API from "../services/api/Api";
import APIFixture from "../services/api/ApiFixture";
import {
	applyCoupon,
	cancelTrial,
	convertToFree,
	generateCode,
	leaveInstance,
	verifyCoupon,
	verifyEmailCode,
} from "./ActivationSaga";

/* SAGAS */
import { initApp } from "./InitAppSaga";
import {
	cancelEssentialsSubscription,
	cancelSubscription,
	invoice,
	orderSummary,
	processAddressForm,
	processFreeTrial,
	processPayPalPayment,
	processPayment,
	sendPaymentToken,
} from "./PaymentSaga";
import { getProducts } from "./ProductsSaga";
import {
	activateAccount,
	deleteMembers,
	editUserDetails,
	getUser,
	getUserContext,
	getUserInviteInfo,
	getUserProductOptions,
	setUserAttribute,
	useInviteCode,
	verifyTeacherEmail,
} from "./UserSaga";

let api;
/* istanbul ignore else */
if (process.env.NODE_ENV === "test") {
	api = APIFixture;
} else {
	api = API.create();
}

export default function* root() {
	yield all([
		takeLatest(InitAppTypes.INIT_APP, initApp, api),

		takeLatest(UserTypes.GET_USER, getUser, api),
		takeLatest(UserTypes.GET_USER_CONTEXT, getUserContext, api),
		takeLatest(UserTypes.GET_USER_PRODUCT_OPTIONS, getUserProductOptions, api),
		takeLatest(UserTypes.SET_USER_ATTRIBUTE, setUserAttribute, api),
		takeLatest(UserTypes.ACTIVATE_ACCOUNT, activateAccount, api),
		takeLatest(UserTypes.EDIT_USER_DETAILS, editUserDetails, api),
		takeLatest(UserTypes.DELETE_MEMBERS, deleteMembers, api),
		takeLatest(UserTypes.VERIFY_TEACHER_EMAIL, verifyTeacherEmail, api),
		takeLatest(UserTypes.GET_USER_INVITE_INFO, getUserInviteInfo, api),
		takeLatest(UserTypes.USE_INVITE_CODE, useInviteCode, api),

		takeLatest(PaymentTypes.SEND_PAYMENT_TOKEN, sendPaymentToken, api),
		takeLatest(PaymentTypes.PROCESS_PAYMENT, processPayment, api),
		takeLatest(PaymentTypes.PROCESS_PAY_PAL_PAYMENT, processPayPalPayment, api),
		takeLatest(PaymentTypes.PROCESS_FREE_TRIAL, processFreeTrial, api),
		takeLatest(PaymentTypes.INVOICE, invoice, api),
		takeLatest(PaymentTypes.ORDER_SUMMARY, orderSummary, api),
		takeLatest(PaymentTypes.PROCESS_ADDRESS_FORM, processAddressForm, api),
		takeLatest(PaymentTypes.CANCEL_ESSENTIALS, cancelEssentialsSubscription, api),
		takeLatest(PaymentTypes.CANCEL_SUBSCRIPTION, cancelSubscription, api),

		takeLatest(ActivationTypes.VERIFY_EMAIL_CODE, verifyEmailCode, api),
		takeLatest(ActivationTypes.GENERATE_CODE, generateCode, api),
		takeLatest(ActivationTypes.CONVERT_TO_FREE, convertToFree, api),
		takeLatest(ActivationTypes.CANCEL_TRIAL, cancelTrial, api),
		takeLatest(ActivationTypes.VERIFY_COUPON, verifyCoupon, api),
		takeLatest(ActivationTypes.LEAVE_INSTANCE, leaveInstance, api),
		takeLatest(ActivationTypes.APPLY_COUPON, applyCoupon, api),

		takeLatest(ProductsTypes.GET_PRODUCTS, getProducts, api),
	]);
}
